import _objectSpread from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import { jsx } from 'react/jsx-runtime';
import * as RadixPopover from '@radix-ui/react-popover';
/**
 * The Popover component has a trigger which displays a Card to the user with customizable content.
 */

var PopoverRoot = function PopoverRoot(props) {
  var children = props.children,
      rest = _objectWithoutProperties(props, _excluded);

  return jsx(RadixPopover.Root, _objectSpread(_objectSpread({
    modal: true
  }, rest), {}, {
    children: children
  }));
};

PopoverRoot.displayName = 'PopoverRoot';
export { PopoverRoot };